import * as React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import html2pdf from "html2pdf.js";
import { Button } from "@mui/material";
import ReactToPrint from "react-to-print";
import { useSelector } from "react-redux";
import "./printBilling.css";
import { ApplyAccordingREAndCBUser } from "../features/counterSellBilling/counterSellBillFunctions";

import {
  receiptDateFormate,
  receptTime,
} from "./commonUtils/commonUtilFunction";
import QrCodeGenrate from "./qrCodeGenerate";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function PrintBillingPdf({
  componentRef,
  currentDataArr,
  tableName,
  userDetail,
  addDataCallBack,
  customerMobile,
  setKOT,
  paybill,
  setOpen2,
  payableBilUpdateBill,
  totalAmountBill,
  discountAmount,
  bill,
  addtoCardProductCBUser,
  priceWithoutGst,
  billNoR 
}) {
  const billNumber = useSelector((state) => state.reducer.billNumber);
  const handlePrint = () => {
    if (componentRef && componentRef.current) {
      componentRef?.current?.onClick();
    }
  };

  React.useEffect(() => {
    console.log("componentRef ", componentRef);
  }, []);
  const handleDownloadPdf = async () => {
    const element = componentRef.current;

    // Options for the PDF
    const options = {
      margin: 0.5, // Margin of the PDF
      filename: "my-document.pdf", // PDF filename
      image: { type: "jpeg", quality: 0.98 }, // Image quality
      html2canvas: { scale: 2, useCORS: true }, // Options for html2canvas
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" }, // jsPDF options
    };

    // Generate the PDF
    html2pdf().from(element).set(options).save();
  };
  // const userDetail = useSelector((state) => state.reducer.userDetail);

  console.log(paybill, "paybillpaybill");
  return (
    <Box
      sx={{
       background: "white",
        display: "none",
        position: "absolute",
        left: "30%",
        top: "15vh",
        overflowY: "auto",
        maxHeight: "80vh",
        p: "0px 10px",
        width: userDetail?.printerSize == 3 ? "80mm" : "48mm",
        // display:"block",
        // width:"60%"
      }}
    >
      <Button
        onClick={() => {
          handleDownloadPdf();
        }}
      >
        click{" "}
      </Button>
      <Box
        ref={componentRef} // Ensure the ref is assigned here
        sx={{
          minWidth: userDetail?.printerSize === 2 ? "48mm" : "none",
          maxWidth: userDetail?.printerSize === 3 ? "80mm" : "none",
          margin: userDetail?.printerSize === 3 ? "10px" : "0px",
          boxSizing: "border-box",
        }}
      >
        <Grid container>
          <Grid xs={4}>
            {userDetail?.uploadedLogo && (
              <img
                src={userDetail?.uploadedLogo}
                alt="Selected"
                style={{ width: "120px", height: "120px", cursor: "pointer" }}
              />
            )}
          </Grid>

          <Grid xs={12}>
            <Box
              sx={{
                textAlign: "center",
              }}
            ></Box>

            <Typography
              variant="subtitle1"
              textAlign="center"
              sx={{
                margin: "0px",
                p: "0px",
                fontSize: "14px",

                lineHeight: "1.2",
              }}
            >
              {userDetail?.myBusinessName}
            </Typography>
            <Typography
              variant="subtitle1"
              textAlign="center"
              sx={{
                margin: "6px",
                p: "0px",
                fontSize: "14px",

                lineHeight: "1.2",
              }}
            >
              {userDetail?.billerAddress}
            </Typography>
            <Typography
              variant="subtitle1"
              textAlign="center"
              sx={{
                margin: "0px",
                p: "0px",
                fontSize: "14px",

                lineHeight: "1.2",
              }}
            >
              PH-NO: {userDetail?.mobileNumber}
            </Typography>
            {/* <Typography
          variant="subtitle1"
          textAlign="center"
          sx={{
            margin: "0px",
            p: "0px",
            fontSize: "18px",

            lineHeight: "1.2", 
          }}
        >
             BILL NO :{billNumber + 1}
            {"    "}
            <span style={{ margin: "4px" }}></span>
            {receiptDateFormate()}
            {"  "}
            {receptTime()}
          
        </Typography> */}
            {/* <Typography
          variant="subtitle1"
          textAlign="center"
          sx={{
            margin: "0px",
            p: "0px",
            fontSize: "18px",

            lineHeight: "1.2", 
          }}
        >
           
           {ApplyAccordingREAndCBUser(
              userDetail,
              () => tableName,
              () => ""
            )}
          
        </Typography> */}
            {/* <Box
          sx={{
            width: "100%",
          }}
        >
          <Typography
          variant="subtitle1"
          textAlign="center"
          sx={{
            margin: "0px",
            p: "0px", 
                          fontSize: userDetail?.printerSize == 3 ? "18px" : "12px",


            lineHeight: "1.2",
            fontWeight: "600",
          }}
       
           
          >
            {userDetail?.billerAddress}
          </Typography>
          <Typography
          variant="subtitle1"
          textAlign="center"
          sx={{
            margin: "0px",
            p: "0px",  
            

              fontSize: userDetail?.printerSize == 3 ? "18px" : "12px",

            lineHeight: "1.2",
            fontWeight: "600",
          }}
       
           
            
          >
            PH-NO:{userDetail?.mobileNumber}
          </Typography>

          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{
              margin: "0px",
              lineHeight: "1.2",
              // p: "0px 0px 0px 0px",
              m: "0px 10px 0px 0px",
              fontSize: userDetail?.printerSize == 3 ? "18px" : "11px",
            }}
          >
            BILL NO :{billNumber + 1}
            {"    "}
            <span style={{ margin: "4px" }}></span>
            {receiptDateFormate()}
            {"  "}
            {receptTime()}
          </Typography>
          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{
              margin: "0px",: 
              lineHeight: "1.2",
              fontSize: "20px", 
            }}
          >
            {ApplyAccordingREAndCBUser(
              userDetail,
              () => tableName,
              () => ""
            )}
          </Typography>
        </Box> */}
          </Grid>
        </Grid>
        <Grid container>
          <Grid xs={12}>
            <Typography
              variant="h3"
              textAlign="center"
              sx={{
                fontWeight: "bold",
                color: "#002d62",
                margin: "24px",
                p: "0px",
                lineHeight: "1.2",
                fontSize: "24px",
              }}
            >
              INVOICE
            </Typography>
          </Grid>
          <Grid xs={6}>
            <Typography
              variant="h4"
              textAlign="left"
              sx={{
                fontWeight: "bold",
                color: "#002d62",
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
                fontSize: "20px",
              }}
            >
              Customer Name
            </Typography>
            <Typography
              textAlign="left"
              sx={{
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
              }}
            >
              {bill?.customer ? bill?.customer : "Cash bill"}
            </Typography>
          </Grid>
          <Grid xs={6}>
  <Typography
              variant="h4"
              textAlign="left"
              sx={{
                fontWeight: "bold",
                color: "#002D62",
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
                fontSize: "20px",
              }}
            >
             Mobile Number
            </Typography>
            <Typography
              textAlign="left"
              sx={{
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
              }}
            >
              {  customerMobile ??0}
            </Typography>
          </Grid>
          <Grid xs={6} sx={{ marginTop: "20px" }}>
            <Typography
              variant="h4"
              textAlign="left"
              sx={{
                fontWeight: "bold",
                color: "#002D62",
                fontWeight: "bold",
                color: "#002D62",
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
                fontSize: "20px",
              }}
            >
              Invoice No
            </Typography> 
            <Typography
              textAlign="left"
              sx={{
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
              }}
            > 
              {billNoR}
            </Typography>
          </Grid>

          <Grid xs={6} sx={{ marginTop: "20px" }}>
            <Typography
              variant="h4"
              textAlign="left"
              sx={{
                fontWeight: "bold",
                color: "#002d62",
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
                fontSize: "20px",
              }}
            >
              Date
            </Typography>
            <Typography
              textAlign="left"
              sx={{
                margin: "0px",
                p: "0px",
                lineHeight: "1.2",
              }}
            >
              {receiptDateFormate()}
              {"  "}
              {receptTime()}
            </Typography>
          </Grid>
        </Grid>

        <Box
          sx={{
            paddingLeft: userDetail?.printerSize === 3 ? "10px" : "0px",
            marginTop: "24px",
          }}
        >
          <Grid container>
            <Grid
              item
              container
              sx={
                {
                  // borderBottom: "1px solid black",
                  // borderTop: "1px solid black",
                }
              }
            >
              <Grid
                item
                container
                sx={{
                  borderBottom: "2px solid black",
                  paddingBottom: "12px",
                }}
              >
                <Grid item xs={3} sx={{ fontSize: "14px" }}>
                  <Typography
                    variant="h4"
                    textAlign="left"
                    sx={{
                      fontWeight: "bold",
                      color: "#002d62",
                      margin: "0px",
                      p: "0px",
                      lineHeight: "1.2",
                      fontSize: "20px",
                    }}
                  >
                    ITEM
                  </Typography>
                </Grid>

                <Grid item xs={1} sx={{ fontSize: "14px" }}>
                  <Typography
                    variant="h4"
                    textAlign="left"
                    sx={{
                      fontWeight: "bold",
                      color: "#002d62",
                      margin: "0px",
                      p: "0px",
                      lineHeight: "1.2",
                      fontSize: "20px",
                    }}
                  >
                    QTY
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ fontSize: "14px", textAlign: "center" }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      color: "#002d62",
                      margin: "0px",
                      p: "0px",
                      lineHeight: "1.2",
                      fontSize: "20px",
                    }}
                  >
                    RATE
                  </Typography>
                </Grid>
                {/* <Grid
                  sx={{ fontSize: "14px", textAlign: "center" }}
                  item
                  xs={3}
                >
                  GST
                </Grid> */}
                <Grid sx={{ fontSize: "14px" }} item xs={4}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      color: "#002d62",
                      margin: "0px",
                      p: "0px",
                      lineHeight: "1.2",
                      fontSize: "20px",
                    }}
                  >
                    TOTAL
                  </Typography>
                </Grid>
              </Grid>

              {ApplyAccordingREAndCBUser(
                userDetail,
                () => {
                  return currentDataArr;
                },
                () => {
                  return addtoCardProductCBUser;
                }
              )?.length > 0 &&
                ApplyAccordingREAndCBUser(
                  userDetail,
                  () => {
                    return currentDataArr;
                  },
                  () => {
                    return addtoCardProductCBUser;
                  }
                )?.map((ele, index) => {
                  console.log("eee update ", ele, " ", index);
                  return (
                    <React.Fragment key={"Billinglist" + index}>
                      <Grid
                        container
                        sx={{
                          borderBottom: "2px solid black",
                          padding: "12px",
                          marginBottom: "12px",
                        }}
                      >
                        <Grid
                          item
                          xs={3}
                          sx={{
                            fontSize: "17px",
                            // borderBottom: "1px solid black",
                          }}
                        >
                          <Typography></Typography>

                          {}
                          {ApplyAccordingREAndCBUser(
                            userDetail,
                            () => {
                              return ele[1] === undefined
                                ? ele.itemDescription
                                : ele[1].itemDescription;
                            },
                            () => {
                              return ele.itemDescription;
                            }
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={1}
                          sx={{
                            fontSize: "17px",
                            // borderBottom: "1px solid black",

                            overflowWrap: "break-word !important",
                          }}
                        >
                          {" "}
                          {ApplyAccordingREAndCBUser(
                            userDetail,
                            () => {
                              return ele[1] === undefined
                                ? ele.quantity
                                : ele[1].suppliedQuantity;
                            },
                            () => {
                              return ele.suppliedQuantity;
                            }
                          )}
                          {}
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            fontSize: "17px",
                            // borderBottom: "1px solid black",

                            textAlign: "center",

                            paddingX: "2px",
                            overflowWrap: "break-word !important",
                          }}
                        >
                          {ApplyAccordingREAndCBUser(
                            userDetail,
                            () => {
                              return ele[1] === undefined
                                ? ele.rate?.toFixed(1)
                                : ele[1].currentPrice?.toFixed(1);
                            },
                            () => {
                              return ele.currentPrice
                                ? ele.currentPrice?.toFixed(1)
                                : ele.price?.toFixed(1);
                            }
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            fontSize: "17px",
                            textAlign: "left",
                            // borderBottom: "1px solid black",

                            overflowWrap: "break-word !important",
                          }}
                        >
                          {ApplyAccordingREAndCBUser(
                            userDetail,
                            () => {
                              return ele[1] === undefined
                                ? (ele.rate * ele.quantity).toFixed(1)
                                : (
                                    ele[1].currentPrice *
                                    ele[1].suppliedQuantity
                                  )?.toFixed(1);
                            },
                            () => {
                              return ele?.suppliedQuantity
                                ? (
                                    ele.currentPrice * ele.suppliedQuantity
                                  )?.toFixed(1)
                                : (ele.price * ele.quantity).toFixed(1);
                            }
                          )}
                          {}
                          {/* {ele[1].currentPrice +
                            ele[1].currentPrice * (ele[1].gst / 100)} */}
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
                })}
            </Grid>
            {false && (
              <Grid
                item
                xs={12}
                sx={{
                  textAlign: "center",
                  fontWeight: "500",

                  paddingY: "5px",
                }}
              >
                <Typography
                  variant="h4"
                  textAlign="left"
                  sx={{
                    fontWeight: "bold",
                    color: "#002d62",
                    margin: "0px",
                    p: "0px",
                    lineHeight: "1.2",
                    fontSize: "20px",
                  }}
                >
                  SUBTOTAL AMOUNT:
                  <Typography
                    variant="span"
                    sx={{
                      overflowWrap: "break-word !important",
                      fontWeight: "200",
                      fontSize: "15px",
                      color: "black",
                    }}
                  >
                    : Rs. {paybill ? totalAmountBill : totalAmountBill}{" "}
                  </Typography>
                </Typography>

                <Typography
                  sx={{
                    overflowWrap: "break-word !important",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  {/* Discount: RS. {(paybill ? discountAmount : discountAmount)?.toFixed(2)}{" "} */}
                </Typography>
              </Grid>
            )}
         {true && (
          <> 
             <Grid
              item
              xs={8}
              sx={{
                textAlign: "right",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  color: "#002d62",
                  margin: "0px",
                  p: "0px",
                  lineHeight: "1.2",
                  fontSize: "20px",
                }}
              >
                SUBTOTAL AMOUNT:
              </Typography>
            </Grid>
            
            <Grid
              item
              xs={4}
              sx={{
                textAlign: "left",
                paddingLeft: "34px",
              }}
            >
              <Typography
                variant="span"
                sx={{
                  overflowWrap: "break-word !important",
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "black",
                }}
              >
                Rs.{Math.abs(priceWithoutGst??0)?.toFixed(2)}{" "}
              </Typography>
            </Grid>
            </>

         )

         }
            <Grid
              item
              xs={8}
              sx={{
                textAlign: "right",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  color: "#002d62",
                  margin: "0px",
                  p: "0px",
                  lineHeight: "1.2",
                  fontSize: "20px",
                }}
              >
                GST:
              </Typography>
            </Grid>
            <Grid xs={4} sx={{ textAlign: "left", paddingLeft: "34px" }}>
              <Typography
                variant="span"
                sx={{
                  overflowWrap: "break-word !important",
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "black",
                }}
              >
                Rs.{Math.abs(paybill - priceWithoutGst)?.toFixed(2)}{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={8}
              sx={{
                textAlign: "right",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  color: "#002d62",
                  margin: "0px",
                  p: "0px",
                  lineHeight: "1.2",
                  fontSize: "20px",
                }}
              >
                TOTAL AMOUNT:
              </Typography>
            </Grid>
            <Grid
              xs={4}
              sx={{
                textAlign: "left",
                paddingLeft: "34px",
              }}
            >
              <Typography
                variant="span"
                sx={{
                  overflowWrap: "break-word !important",
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "black",
                }}
              >
                Rs.
                {/* {paybill ? paybill?.toFixed(2) : 0} */}
                {paybill }{" "}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                textAlign: "left",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  color: "#002d62",
                  margin: "0px",
                  p: "0px",
                  lineHeight: "1.2",
                  fontSize: "19px",
                }}
              >
                TERMS AND CONDITIONS
              </Typography>
            </Grid>

            {/* {userDetail?.isPrintQRCodeOnBill && ( */}
            {true && (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  mt: 1,
                }}
              >
                <QrCodeGenrate
                  amount={
                    paybill??0
                      // ? paybill?.toFixed(2)
                      // : payableBilUpdateBill
                      // ? payableBilUpdateBill()?.toFixed(2)
                      // : 0?.toFixed(2)
                  }
                  height="150px"
                  width="150px"
                />
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",

          justifyContent: "space-around",
        }}
      >
        <ReactToPrint
          trigger={() => (
            <Button
              variant="contained"
              sx={{
                mt: "10px",
                display: "inline-block",
                mb: "10px",
              }}
              onClick={() => {
                setKOT();
                addDataCallBack();
                setOpen2(false);
              }}
            >
              {" "}
              Print
            </Button>
          )}
          content={() => componentRef.current}
          onBeforePrint={() => {
            setOpen2(false);

            addDataCallBack();
          }}
        ></ReactToPrint>
        <Button
          variant="contained"
          sx={{
            m: "10px",
          }}
          onClick={() => {
            handlePrint();
          }}
        >
          {" "}
          Share
        </Button>
      </Box>
    </Box>
  );
}
